(function () {
  'use strict';

  var SELECT_SIZE = 'Select a size';
  var ADD_TO_CART = 'Add to cart';
  var HEADER_OFFSET = 60;

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function prefersReducedMotion() {
    try {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (e) {
      return false;
    }
  }

  function getBar() {
    return document.querySelector('[data-pys-sticky-select-bar]');
  }

  function getMainProductRoot() {
    return (
      document.querySelector('product-info form.main-product-form') ||
      document.querySelector('product-info .main-product-form') ||
      document.querySelector('form.main-product-form') ||
      document.querySelector('product-info') ||
      null
    );
  }

  function getObserveTarget() {
    var root = getMainProductRoot();
    var scope = root;
    if (root && root.tagName && root.tagName.toLowerCase() === 'form') {
      scope = root.closest('product-info') || root;
    }

    if (scope) {
      var buttons =
        scope.querySelector('form.main-product-form .product-form__buttons') ||
        scope.querySelector('.product-form__buttons') ||
        scope.querySelector('[id^="QuantityForm-"]');
      if (buttons) return buttons;
    }

    return (
      document.querySelector('product-info form.main-product-form .product-form__buttons') ||
      document.querySelector('form.main-product-form .product-form__buttons') ||
      document.querySelector('product-info .product-form__buttons') ||
      document.querySelector('.product-form__buttons') ||
      null
    );
  }

  function getScrollTarget() {
    return (
      document.getElementById('Size') ||
      document.querySelector('.product-form__input--size') ||
      document.querySelector('variant-selects') ||
      document.querySelector('.product-form__input') ||
      document.querySelector('form.main-product-form .product-form__buttons') ||
      document.querySelector('.product-form__buttons') ||
      document.querySelector('form.main-product-form')
    );
  }

  function sizePicked() {
    var inputs = document.querySelectorAll('.product-form__input--size input[type="radio"]');
    if (!inputs.length) return true;
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].checked) return true;
    }
    return false;
  }

  function syncCta(bar) {
    if (!bar) return;
    var cta = bar.querySelector('[data-pys-sticky-select-bar-cta]');
    var trigger = bar.querySelector('[data-pys-sticky-select-bar-trigger]');
    var hasSize = bar.getAttribute('data-has-size') === 'true';
    var needsSize = hasSize && !sizePicked();
    var label = needsSize ? SELECT_SIZE : ADD_TO_CART;

    var atc = document.querySelector('form.main-product-form [name="add"], .product-form__submit');
    if (atc && atc.classList.contains('pys-atc--needs-size')) {
      label = SELECT_SIZE;
      needsSize = true;
    }

    bar.setAttribute('data-needs-size', needsSize ? 'true' : 'false');
    if (cta) cta.textContent = label;
    if (trigger) {
      var title = bar.querySelector('.pys-sticky-select-bar__title');
      var titleText = title ? title.textContent.trim() : '';
      trigger.setAttribute('aria-label', label + (titleText ? ': ' + titleText : ''));
    }
  }

  function lockPillCircle(card) {
    if (!card) return;
    card.classList.add('is-closed');
    var h = Math.round(card.getBoundingClientRect().height);
    if (h < 8) return;
    var px = h + 'px';
    card.style.width = px;
    card.style.height = px;
    card.style.minWidth = px;
    card.style.maxWidth = px;
    card.style.padding = '';
  }

  function playPillIntro(bar) {
    var card = bar.querySelector('[data-pys-sticky-select-bar-trigger]');
    if (!card) return;

    window.clearTimeout(bar._pysIntroTimer);
    window.clearTimeout(bar._pysIntroClearTimer);

    bar.classList.remove('is-closing');
    card.classList.remove('is-closing');

    if (prefersReducedMotion()) {
      card.classList.remove('is-closed', 'is-closing');
      card.style.width = '';
      card.style.height = '';
      card.style.minWidth = '';
      card.style.maxWidth = '';
      card.style.padding = '';
      return;
    }

    lockPillCircle(card);
    window.requestAnimationFrame(function () {
      lockPillCircle(card);
      bar._pysIntroTimer = window.setTimeout(function () {
        card.classList.remove('is-closed', 'is-closing');
        card.style.height = '';
        card.style.padding = '';
        void card.offsetWidth;
        card.style.maxWidth = 'var(--pys-ssb-max)';
        card.style.width = '';
        card.style.minWidth = '';
        bar._pysIntroClearTimer = window.setTimeout(function () {
          card.style.maxWidth = '';
        }, 1600);
      }, 40);
    });
  }

  function clearCardInline(card) {
    if (!card) return;
    card.style.width = '';
    card.style.height = '';
    card.style.minWidth = '';
    card.style.maxWidth = '';
    card.style.padding = '';
  }

  function finishHide(bar) {
    if (!bar) return;
    var card = bar.querySelector('[data-pys-sticky-select-bar-trigger]');
    if (card) {
      card.classList.remove('is-closing', 'is-closed');
      clearCardInline(card);
    }
    bar.classList.remove('is-closing', 'is-visible');
    bar.setAttribute('aria-hidden', 'true');
    bar.hidden = true;
  }

  function playPillOutro(bar, onDone) {
    var card = bar.querySelector('[data-pys-sticky-select-bar-trigger]');
    if (!card) {
      if (onDone) onDone();
      return;
    }

    window.clearTimeout(bar._pysIntroTimer);
    window.clearTimeout(bar._pysIntroClearTimer);
    window.clearTimeout(bar._pysHideTimer);
    window.clearTimeout(bar._pysOutroTimer);

    if (prefersReducedMotion()) {
      card.classList.remove('is-closing', 'is-closed');
      clearCardInline(card);
      if (onDone) onDone();
      return;
    }

    // Capture open width, then collapse to circle with transitions enabled via is-closing
    var rect = card.getBoundingClientRect();
    var w = Math.max(8, Math.round(rect.width));
    var h = Math.max(8, Math.round(rect.height));
    var circle = h + 'px';

    card.classList.remove('is-closed');
    card.classList.add('is-closing');
    bar.classList.add('is-closing');
    card.style.width = w + 'px';
    card.style.maxWidth = w + 'px';
    card.style.minWidth = w + 'px';
    card.style.height = h + 'px';
    void card.offsetWidth;

    card.classList.add('is-closed');
    card.style.width = circle;
    card.style.height = circle;
    card.style.minWidth = circle;
    card.style.maxWidth = circle;
    card.style.padding = '';

    // Drop off mid-collapse — before it reaches the circle
    bar._pysOutroTimer = window.setTimeout(function () {
      bar._pysOutroTimer = null;
      if (onDone) onDone();
    }, 380);
  }

  function setVisible(bar, show) {
    if (!bar) return;
    var wasVisible = bar.classList.contains('is-visible');
    var card = bar.querySelector('[data-pys-sticky-select-bar-trigger]');
    var wasClosing = !!(bar.classList.contains('is-closing') || (card && card.classList.contains('is-closing')));

    if (show) {
      window.clearTimeout(bar._pysHideTimer);
      window.clearTimeout(bar._pysOutroTimer);
      bar._pysOutroTimer = null;

      if (wasClosing && card) {
        // Cancel outro — expand back open with same ease
        card.classList.remove('is-closing', 'is-closed');
        clearCardInline(card);
        bar.classList.remove('is-closing');
      }

      bar.hidden = false;
      bar.setAttribute('aria-hidden', 'false');
      if (!wasVisible) {
        void bar.offsetWidth;
        bar.classList.add('is-visible');
        playPillIntro(bar);
      } else if (wasClosing) {
        // Stayed visible during outro; ensure open end-state (no re-intro lock)
        if (card) {
          card.classList.remove('is-closed', 'is-closing');
          clearCardInline(card);
        }
      }
    } else {
      if (!wasVisible && bar.hidden && !wasClosing) return;
      if (wasClosing) return; // outro already in flight

      if (prefersReducedMotion()) {
        window.clearTimeout(bar._pysIntroTimer);
        window.clearTimeout(bar._pysIntroClearTimer);
        window.clearTimeout(bar._pysHideTimer);
        finishHide(bar);
        return;
      }

      // Keep is-visible (no outer opacity fade) while pill collapses
      playPillOutro(bar, function () {
        if (!bar.classList.contains('is-closing')) return; // cancelled by show
        finishHide(bar);
      });
    }
  }

  function isModalOpen() {
    // Theme quick-view / drawers only. The AU ship gate must NOT block the sticky bar —
    // sticky sits above it and dismisses the gate on tap so size-scroll works on first press.
    return document.body.classList.contains('modal-show') || document.body.classList.contains('modal-showing');
  }

  function dismissAuShipGate() {
    if (typeof window.pysDismissAuShipModal === 'function') {
      try { window.pysDismissAuShipModal(); } catch (e) {}
      return;
    }
    var ship = document.getElementById('au-ship-modal');
    if (!ship || ship.classList.contains('hidden')) return;
    ship.classList.add('hidden');
    ship.setAttribute('aria-hidden', 'true');
    try { document.body.classList.remove('au-ship-open'); } catch (e) {}
  }

  function shouldShowBar(target) {
    if (isModalOpen()) return false;
    if (!target) return false;
    var rect = target.getBoundingClientRect();
    if (rect.bottom < HEADER_OFFSET) return true;
    if (rect.top < 0 && rect.bottom <= 0) return true;
    return false;
  }

  function updateVisibility(bar, target) {
    setVisible(bar, shouldShowBar(target));
  }

  function scrollToBuyBox(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (isModalOpen()) return;
    // First tap must work even if the AU ship popup is open: clear it, then scroll.
    dismissAuShipGate();
    // Size gate: prefer the shared PDP helper (scroll + "Choose a size" message).
    var bar = getBar();
    var needs =
      (bar && bar.getAttribute('data-needs-size') === 'true') ||
      !sizePicked();
    if (needs && typeof window.pysPromptSize === 'function') {
      window.pysPromptSize();
      return;
    }
    var target = getScrollTarget();
    if (!target) return;
    var reduce = prefersReducedMotion();
    try {
      target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
    } catch (err) {
      target.scrollIntoView(true);
    }
  }

  function init() {
    var bar = getBar();
    if (!bar) return;

    if (bar.parentNode !== document.body) {
      document.body.appendChild(bar);
    }

    var observeTarget = getObserveTarget();
    if (!observeTarget) return;

    syncCta(bar);

    var trigger = bar.querySelector('[data-pys-sticky-select-bar-trigger]');
    if (trigger) trigger.addEventListener('click', scrollToBuyBox);

    var rafPending = false;
    function scheduleUpdate() {
      if (rafPending) return;
      rafPending = true;
      window.requestAnimationFrame(function () {
        rafPending = false;
        updateVisibility(bar, observeTarget);
      });
    }

    if (typeof IntersectionObserver !== 'undefined') {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var rect = entry.boundingClientRect;
            var leftUpward = rect.bottom < HEADER_OFFSET;
            var classicOut = entry.intersectionRatio === 0 && rect.top < 0;
            setVisible(bar, !isModalOpen() && (leftUpward || classicOut));
          });
        },
        {
          threshold: [0, 0.01, 0.1, 0.5],
          rootMargin: '0px 0px 0px 0px'
        }
      );
      observer.observe(observeTarget);
    }

    window.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', scheduleUpdate);
    scheduleUpdate();

    document.addEventListener('variant:changed', function () {
      syncCta(bar);
    });

    document.addEventListener('change', function (event) {
      var t = event.target;
      if (!t || !t.matches) return;
      if (t.matches('.product-form__input--size input[type="radio"]')) {
        syncCta(bar);
      }
    });

    var atc = document.querySelector('form.main-product-form [name="add"], .product-form__submit');
    if (atc && typeof MutationObserver !== 'undefined') {
      var mo = new MutationObserver(function () {
        syncCta(bar);
      });
      mo.observe(atc, { attributes: true, attributeFilter: ['class', 'aria-disabled', 'disabled'] });
    }

    var prev = window.pysSyncAtcSizeGate;
    if (typeof prev === 'function') {
      window.pysSyncAtcSizeGate = function (variant) {
        prev(variant);
        syncCta(bar);
      };
    }
  }

  ready(init);
})();
